import {
  LikeOutlined,
  CommentOutlined,
  PlayCircleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { gameRoute } from '../../../../games/core/routing/gameRoute';
import { apiPHP } from '../../../../services/api';
import { formatDate } from '../../../../utils/formatDate';
import type { HomeGame } from '../../types';
import { Container, Content, Footer, Header } from './styles';

import defaultImg from '../../../../assets/img/logoWhite.png';

interface CardProps {
  game: HomeGame;
  /** Card de vitrine (edição): só exibição — sem jogar, curtir ou comentar. */
  showcase?: boolean;
  openCommentsModal?: (id: number) => void;
  navigateToTournaments?: () => void;
}

/** Formata a data com segurança — `null`/inválida não quebra o render. */
const formatCreatedAt = (value: string | null): string => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : formatDate(date);
};

export const Card: React.FC<CardProps> = ({
  game,
  showcase = false,
  navigateToTournaments,
  openCommentsModal,
}: CardProps) => {
  const navigate = useNavigate();

  const handleToggleLike = async () => {
    try {
      await apiPHP
        .get(`/curtir/passatempos/${game.id_jogo}`)
        .catch(() => apiPHP.get(`/descurtir/passatempos/${game.id_jogo}`));
    } catch (err) {
      console.log(err);
    }
  };

  const navigateToGame = () => {
    const route = gameRoute(game.id_tipo, game.id_jogo);
    if (route) navigate(route);
  };

  const onOpen = showcase
    ? undefined
    : navigateToTournaments !== undefined
    ? navigateToTournaments
    : navigateToGame;

  return (
    <Container>
      <Header level={game.id_dificuldade ? game.id_dificuldade : 2}>
        <p>
          {game.id_dificuldade
            ? game.id_dificuldade === 1
              ? 'Fácil'
              : game.id_dificuldade === 2
              ? 'Médio'
              : 'Difícil'
            : 'Médio'}
        </p>
        {!showcase && (
          <div>
            <span>
              <LikeOutlined /> 10
            </span>
            <span>
              <CommentOutlined /> 15
            </span>
          </div>
        )}
      </Header>

      <Content {...(onOpen && { onClick: onOpen })}>
        <span>
          <img src={defaultImg} alt={game.titulo} className="swiper-lazy" />
        </span>

        <div>
          <span>
            <h1>{game.titulo}</h1>
            <h2>{game.subtitulo === '.' ? '' : game.subtitulo}</h2>
          </span>
          <span>
            <h2>{formatCreatedAt(game.created_at)}</h2>
          </span>
        </div>
      </Content>

      {!showcase && (
        <Footer>
          <button type="button" onClick={handleToggleLike}>
            <LikeOutlined />
          </button>
          <button type="button" onClick={() => openCommentsModal?.(game.id_jogo)}>
            <CommentOutlined />
          </button>
          <button
            type="button"
            onClick={
              navigateToTournaments !== undefined ? navigateToTournaments : navigateToGame
            }
          >
            <PlayCircleOutlined />
          </button>
        </Footer>
      )}
    </Container>
  );
};
